import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import checkmark from '../../../assets/checkmark.png';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import moment from 'moment';

export const ThankyouAlert = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={props.handleClose} open={props?.open}>
      <Box className={classes.root}>
         <IconButton onClick={props.handleClose} className={classes.closeIcon}>
           <CancelIcon />
         </IconButton>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>Promise to Pay Scheduled</Typography>
        </Box>
        
        <Box className={classes.cardBodyContainer}>
          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
              {/* <img className={classes.checkImg} src={checkmark} alt='img' />  */}
              <span className={classes.request}>Your promise to pay ${props?.submitAmount} on {moment(props?.selectedDate).format('MM/DD/YYYY')} has been successfully submitted.</span>                
             <Typography className={classes.processed}>No payment has been processed today.</Typography> 
             <Typography className={classes.paragraph}>A confirmation email has been sent to your <b>registered email address</b>.</Typography> 
             <Typography className={classes.paragraph}>If you do not see it, please check your spam folder.</Typography> 
            </Box> 
          </Box>
        </Box>

        <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={props.handleClose}
            >Got it</Button>
        </Box>
      </Box> 
    </Dialog>
  )
}
